import { setFlashMessage } from './flashMessage';
import * as dispositivosAPI from '../services/dispositivos.api';
import {
    CAMBIAR_ESTADO_DISPOSITIVO_REQUEST,
    CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
    CAMBIAR_ESTADO_DISPOSITIVO_ERROR,
    GET_ESTADO_DISPOSITIVOS_REQUEST,
    GET_ESTADO_DISPOSITIVOS_SUCCESS,
    GET_ESTADO_DISPOSITIVOS_ERROR,
    CONFIGURAR_ALWAYS_ON_REQUEST,
    CONFIGURAR_ALWAYS_ON_SUCCESS,
    CONFIGURAR_ALWAYS_ON_ERROR,
    CAMBIO_ESTADO_MASIVO_REQUEST,
    CAMBIO_ESTADO_MASIVO_SUCCESS,
    CAMBIO_ESTADO_MASIVO_ERROR
} from './types';

// Cambiar estado individual - Tarjeta
export const cambiarEstadoTarjeta = (tarjetaId, nuevoEstado) => {
    return async (dispatch) => {
        dispatch({ type: CAMBIAR_ESTADO_DISPOSITIVO_REQUEST });
        
        try {
            const response = await dispositivosAPI.cambiarEstadoTarjeta(tarjetaId, nuevoEstado);
            
            dispatch({
                type: CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
                payload: {
                    tipo: 'tarjeta',
                    dispositivo: response.tarjeta,
                    sensoresAfectados: response.sensoresAfectados || []
                }
            });

            const mensaje = nuevoEstado ? 
                `Tarjeta "${response.tarjeta.nombre}" encendida exitosamente` :
                `Tarjeta "${response.tarjeta.nombre}" apagada exitosamente`;
            
            if (response.sensoresAfectados?.length > 0) {
                dispatch(setFlashMessage(`${mensaje} (${response.sensoresAfectados.length} sensores afectados)`, 'success'));
            } else {
                dispatch(setFlashMessage(mensaje, 'success'));
            }
            
            return response;
            
        } catch (error) {
            const errorMessage = error.message || 'Error al cambiar estado de la tarjeta';
            
            dispatch({
                type: CAMBIAR_ESTADO_DISPOSITIVO_ERROR,
                payload: errorMessage
            });
            
            dispatch(setFlashMessage(errorMessage, 'error'));
            throw error;
        }
    };
};

// Cambiar estado individual - Sensor
export const cambiarEstadoSensor = (sensorId, nuevoEstado) => {
    return async (dispatch) => {
        dispatch({ type: CAMBIAR_ESTADO_DISPOSITIVO_REQUEST });
        
        try {
            const response = await dispositivosAPI.cambiarEstadoSensor(sensorId, nuevoEstado);
            
            dispatch({
                type: CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS,
                payload: {
                    tipo: 'sensor',
                    dispositivo: response.sensor
                }
            });

            const mensaje = nuevoEstado ? 
                `Sensor "${response.sensor.nombre}" encendido exitosamente` :
                `Sensor "${response.sensor.nombre}" apagado exitosamente`;
            
            dispatch(setFlashMessage(mensaje, 'success'));
            
            return response;
            
        } catch (error) {
            let errorMessage = error.message || 'Error al cambiar estado del sensor';
            let errorType = 'error';
            
            // Manejo específico para error de tarjeta apagada
            if (error.message && error.message.includes('tarjeta está apagada')) {
                errorMessage = error.message;
                errorType = 'warning';
            }
            
            dispatch({
                type: CAMBIAR_ESTADO_DISPOSITIVO_ERROR,
                payload: errorMessage
            });
            
            dispatch(setFlashMessage(errorMessage, errorType));
            throw error;
        }
    };
};

// Obtener estado de dispositivos de un proyecto
export const getEstadoDispositivosProyecto = (proyectoId, soloApagados = false) => {
    return async (dispatch) => {
        dispatch({ type: GET_ESTADO_DISPOSITIVOS_REQUEST });
        
        try {
            const response = await dispositivosAPI.getEstadoDispositivosProyecto(proyectoId, soloApagados);
            
            dispatch({
                type: GET_ESTADO_DISPOSITIVOS_SUCCESS,
                payload: response
            });
            
            return response;
            
        } catch (error) {
            const errorMessage = error.message || 'Error al obtener estado de dispositivos';
            
            dispatch({
                type: GET_ESTADO_DISPOSITIVOS_ERROR,
                payload: errorMessage
            });
            
            throw error;
        }
    };
};

// Control masivo de dispositivos
export const cambiarEstadoMasivo = (nuevoEstado, dispositivos) => {
    return async (dispatch) => {
        dispatch({ type: CAMBIO_ESTADO_MASIVO_REQUEST });
        
        try {
            const response = await dispositivosAPI.cambiarEstadoMasivo(nuevoEstado, dispositivos);
            
            dispatch({
                type: CAMBIO_ESTADO_MASIVO_SUCCESS,
                payload: response
            });

            const mensaje = nuevoEstado ? 
                `${response.exitosos.length} dispositivos encendidos exitosamente` :
                `${response.exitosos.length} dispositivos apagados exitosamente`;
            
            dispatch(setFlashMessage(mensaje, 'success'));
            
            if (response.fallidos?.length > 0) {
                dispatch(setFlashMessage(`${response.fallidos.length} dispositivos no pudieron cambiarse`, 'warning'));
            }
            
            return response;
            
        } catch (error) {
            const errorMessage = error.message || 'Error en el cambio masivo de dispositivos';
            
            dispatch({
                type: CAMBIO_ESTADO_MASIVO_ERROR,
                payload: errorMessage
            });
            
            dispatch(setFlashMessage(errorMessage, 'error'));
            throw error;
        }
    };
};

// Configurar dispositivos que no pueden apagarse (solo admin/superadmin)
export const configurarAlwaysOn = (dispositivos) => {
    return async (dispatch) => {
        dispatch({ type: CONFIGURAR_ALWAYS_ON_REQUEST });
        
        try {
            const response = await dispositivosAPI.configurarAlwaysOn(dispositivos);
            
            dispatch({
                type: CONFIGURAR_ALWAYS_ON_SUCCESS,
                payload: response
            });

            dispatch(setFlashMessage('Configuración de dispositivos actualizada exitosamente', 'success'));
            
            return response;
            
        } catch (error) {
            const errorMessage = error.message || 'Error al configurar dispositivos';
            
            dispatch({
                type: CONFIGURAR_ALWAYS_ON_ERROR,
                payload: errorMessage
            });
            
            dispatch(setFlashMessage(errorMessage, 'error'));
            throw error;
        }
    };
};
